import React, { useEffect } from 'react';
import {
  Route, Redirect, withRouter, useHistory
} from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { get, isEmpty } from 'lodash';
import { getUserAuthentication, getUser } from 'selectors';
import { urlMap } from 'routes/urlMap';
import WonoloSpinnerLoader from 'components/common/loaders/WonoloSpinnerLoader';

const PrivateRoute = ({
  component: Component, auth, user, path, ...rest
}) => {
  const history = useHistory();
  useEffect(() => {
    if (auth) {
      if (!isEmpty(user) && !get(user, 'fetching') && !get(user, 'agreedToTerms')) {
        history.push(urlMap.TERMS_OF_SERVICE);
      }
    }
  }, [path]);

  const getRenderComponent = (props) => {
    if (get(user, 'fetching') || isEmpty(user)) {
      return <WonoloSpinnerLoader />;
    }
    if (auth) {
      return <Component {...props} />;
    }
    return <Redirect to={{ pathname: urlMap.SIGNIN }} />;
  };

  return (
    <Route
      {...rest}
      path={path}
      render={getRenderComponent}
    />
  );
};

PrivateRoute.propTypes = {
  component: PropTypes.oneOfType([PropTypes.node, PropTypes.func, PropTypes.object]).isRequired,
  location: PropTypes.object.isRequired,
  auth: PropTypes.bool.isRequired,
  user: PropTypes.shape({
    agreedToTerms: PropTypes.bool.isRequired,
    canPostJobs: PropTypes.bool.isRequired
  }).isRequired,
  path: PropTypes.string.isRequired
};

const mapStateToProps = state => ({
  auth: getUserAuthentication(state),
  user: getUser(state)
});

// for testing export unconnected private route
export const UnconnectedPrivateRoute = withRouter(PrivateRoute);

export default withRouter(connect(mapStateToProps)(PrivateRoute));
